/* eslint-disable no-console */
const customProductPagePopup = {
  init: function () {
    // comment to remove overlay
    // this.bindOpenModal();
    $(window).on('popstate', function (e) {
      window.location.reload();
    });
    if ($('#productPageName').val() === 'ProductPage' || $('#productPageName').val() === 'fluidPcp') {
      $('body').addClass('oc-enabled');
    }
  },
  bindOpenModal: function () {
    $('body').on('click', '.js-customize-open-modal', function (e) {
      e.preventDefault();
      const customUrl = $(this).attr('href');
      customProductPagePopup.openModal(customUrl);
      if (window.applePayDesktopInst) {
        window.applePayDesktopInst.initialize();
        window.applePayDesktopInst.preprocess();
      } else if (window.applePayMobileInst) {
        window.applePayMobileInst.initialize();
        window.applePayMobileInst.preprocess();
      }
    });
  },

  addFluidScript: function () {
    const scr = $('<script id="fluid-configure-script">');
    if ($('#fluid-configure-script').length === 0) {
      scr.attr('src', fluidScriptUrl); // eslint-disable-line
      $('.one-configurator-modal').append(scr);
    }
  },
  openModal: function (customUrl) {
    this.addFluidScript();
    $('.one-configurator-modal').addClass('visible');
    $('body').addClass('oc-overlay-open');
    this.changeUrl(customUrl);
  },
  changeUrl: function (customUrl) {
    const customPdpUrl = customUrl;
    window.history.pushState('', '', customPdpUrl);
  },
};

customProductPagePopup.init();

// comment to remove overlay
// const getPdpUrl = window.location.pathname;
window.closePDP = function () {
  window.closePCP();
  // comment to remove overlay
  // $('body').removeClass('oc-overlay-open');
  // if (window.applePayDesktopInst) {
  //   window.applePayDesktopInst.initialize();
  //   window.applePayDesktopInst.preprocess();
  // }
  // if (window.applePayMobileInst) {
  //   window.applePayMobileInst.initialize();
  //   window.applePayMobileInst.preprocess();
  // }
  // window.history.pushState('', '', getPdpUrl);
  // $('.one-configurator-modal').removeClass('visible');
};

window.closePCP = function (parent) {
  const currentURL = $('#currentUrl').val();
  if (parent == 'logo') {
    window.location.href = currentURL;
  } else {
    window.history.back();
  }
};

window.recipeLoading = false;
// let sizeChangedObserver = false;

const getJson = (err, json) => {
  window.recipe = json;
};

const disableApplePayBtn = () => {
  if (document.querySelector('.fc-apple-pay')) {
    observeOverlay.disconnect(); // eslint-disable-line
    document.querySelector('.fc-apple-pay').classList.add('applepay-loading');
    $('.apple-pay-button-proceed').after(' <i class="fa fa-pulse fa-spinner fa-2x"></i>');
  }
};

const tryToLoadRecipe = () => {
  if (!window.recipeLoading) {
    window.recipeLoading = true;
    _getAddToCartRecipe(getJson) // eslint-disable-line
      .then(function () {
        console.log('recipe ready');
        document.querySelector('.fc-apple-pay').classList.remove('applepay-loading');
        $('.fa-spinner').remove();
        observeOverlay.observe(document.querySelector('.fc-dialog-wrapper-container'), { // eslint-disable-line
          subtree: true,
          childList: true,
        });
      })
      .catch(function () {
        document.querySelector('.fc-apple-pay').classList.add('applepay-disabled');
      })
      .finally(function () {
        window.recipeLoading = false;
      });
  }
};

const observeSizeSelect = () => {
  new MutationObserver(function (mutations2) {
    console.log('changed size');
    disableApplePayBtn();
    tryToLoadRecipe();
  }).observe(document.querySelector('.fc-sizes-list'), {
    attributes: true,
    subtree: true,
    childList: true,
  });
};

const observeOverlay =
  new MutationObserver(function (mutations) {
    const el = document.getElementById("D_PCP_ExpressCheckout_ApplePay");
    if (el) {
      console.log('element found');
      if (window.applePayDesktopInst) {
        window.applePayDesktopInst.triggerApplePay();
      } else if (window.applePayMobileInst) {
        window.applePayMobileInst.triggerApplePay();
      }
      disableApplePayBtn();
      tryToLoadRecipe();
      // if (!sizeChangedObserver) {
      // sizeChangedObserver = true;
      observeSizeSelect();
      // }
    }
  });

document.addEventListener("DOMContentLoaded", function (event) {
  const container = document.getElementsByTagName('body');
  if ($('#productPageName').val() === 'fluidPcp' && window.ApplePaySession) {
  // comment to remove overlay
  // if ($('#productPageName').val() === 'ProductPage' || $('#productPageName').val() === 'fluidPcp') {
    observeOverlay.observe(container[0], {
      subtree: true,
      childList: true,
    });
  }
});



// WEBPACK FOOTER //
// ./common/product/fluidRB.js